module.exports = __webpack_public_path__ + "static/iphone-ios-3198ba3bbdf1ed7b2c9c5579f451a155.png";